export default "__VITE_ASSET__D0A4JxC9__"